import type { RenderItemProps } from '@/components/StructuredVirtualList'

import { RegionItem } from './components/RegionItem'

type Props = RenderItemProps<'regions'>

export function Item(props: Props) {
  return props.type === 'item' ? <RegionItem {...props} /> : null
}
